import { render, staticRenderFns } from "./AddSpecialist.vue?vue&type=template&id=7b412d40&scoped=true&"
import script from "./AddSpecialist.vue?vue&type=script&lang=js&"
export * from "./AddSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./AddSpecialist.vue?vue&type=style&index=0&id=7b412d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b412d40",
  null
  
)

export default component.exports